import { useSidebar } from '@contexts/sidebar';
import { OrderStatusTabs } from '@features/orders';
import { useV2StatusCountsState } from '@features/orders/hooks/use-v2-status-counts';

/*
 * Where the legacy pages hand the sidebar's counts to `features/orders`. On V2
 * (EN-4117) the page provides its own counts instead, and the sidebar is not read.
 */
export default function OrderTabMenu() {
  const { data } = useSidebar() as {
    data?: { orders?: { fulfillment_status?: string; count?: number }[] };
  };
  const v2Counts = useV2StatusCountsState();

  return <OrderStatusTabs counts={v2Counts ? v2Counts.rows : data?.orders} />;
}
